import ChartCard from './chartCard.component';

export default ChartCard;